import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const DotContainer = styled.div`
	position: relative;
	display: inline-block;
	padding-top: 2px;
`;

export const Dot = styled.div`
	display: inline-block;
	width: 4px;
	height: 4px;
	border-radius: 50%;
	margin: 0 2px;
	animation: dot-animation 1500ms infinite ease-out;
	background-color: var(--color-white-m);

	&:nth-child(2) {
		animation-delay: 375ms;
	}

	&:nth-child(3) {
		animation-delay: 750ms;
	}

	@keyframes dot-animation {
		0% {
			background-color: var(--color-white-m);
			transform: scale(1);
		}
		25% {
			background-color: var(--color-white-solid);
			transform: scale(1.5);
		}
		75% {
			background-color: var(--color-white-m);
			transform: scale(1);
		}
		100% {
			background-color: var(--color-white-m);
			transform: scale(1);
		}
	}
`;
